/**
 * After a new deploy the old build's code chunks are gone. A tab that was open
 * before the deploy then fails to load a page it has not opened yet ("Failed
 * to fetch dynamically imported module") and shows the error page. Vite
 * reports this as `vite:preloadError`: reload once to get the new build.
 * A short-lived flag prevents a reload loop if the chunk is missing for
 * another reason.
 */
const FLAG = 'pnet_stale_build_reload_at';
const WINDOW_MS = 30_000;

export function installStaleBuildReload(target: Window = window): void {
  target.addEventListener('vite:preloadError', (event) => {
    let last = 0;
    try {
      last = Number(target.sessionStorage.getItem(FLAG) ?? 0);
    } catch {
      /* storage blocked: fall through and reload once */
    }
    if (Date.now() - last < WINDOW_MS) return; // already reloaded just now: show the error
    try {
      target.sessionStorage.setItem(FLAG, String(Date.now()));
    } catch {
      /* ignore */
    }
    event.preventDefault();
    target.location.reload();
  });
}
